// Firebase configuration for Cincinnati Open
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Get Firebase config from WordPress or use empty placeholders
// The actual values will be injected by WordPress via wp_localize_script
const firebaseConfig = window.firebaseConfig || {
  apiKey: "placeholder",
  authDomain: "placeholder",
  projectId: "placeholder",
  storageBucket: "placeholder",
  messagingSenderId: "placeholder",
  appId: "placeholder",
  databaseURL: "placeholder"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db }; 